import classNames from 'classnames';
import AnimateIn from './AnimateIn';
import SecondaryLink from './SecondaryLink';
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const LinkList = ({ component }) => {
  let links = []
  if (!component.useLinksDirectly) {
    links = component.linklist_plugin.items.map( link => {
      return {
        title: link.title,
        url: link.url,
        source: link.source
      }
    });
  } else {
    links = component.links
  }

  return (
    <AnimateIn className="link-list g-row">
      {component._editable && <StoryblokEditableComment text={component._editable} />}
      {component.title && <h2>{component.title}</h2>}

      <ul className={'link-list__container ' + ( component.numbered ? 'u-nb-list' : 'u-no-list' ) }>
        {links.map(link => (
          <li key={`${link.url}${Math.random()}`} className="link-list__item">
            <SecondaryLink
              title={link.title}
              url={link.url}
              source={link.source}
            />
          </li>
        ))}
      </ul>
    </AnimateIn>
  );
};

export default LinkList;
